import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 20px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 350px;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const CloseIconContainer = styled.div`
    color: #fff;
    position: absolute;
    fontsize: 20px;
    top: 25px;
    right: 25px;
    cursor: pointer;
`;

export const BackIconContainer = styled.div`
    color: #fff;
    position: absolute;
    fontsize: 20px;
    top: 25px;
    left: 25px;
    cursor: pointer;
`;

export const ActivityContainer = styled.div`
    width: 100%;
    min-height: 100px;
    max-height: 800px;

    overflow: scroll;

    &::-webkit-scrollbar {
        display: none;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/style.js